export default {
  'tax.receipt.list.header.number': 'Número',
  'tax.receipt.list.header.serie': 'Série',
  'tax.receipt.list.header.issueDate': 'Data de emissão',
  'tax.receipt.list.header.receiver': 'Destinatário',
  'tax.receipt.list.header.situation': 'Situação',
  'tax.receipt.list.searchBar.button': 'Nova Nota',
  'tax.receipt.list.searchBar.filter.company': 'Selecione uma empresa',
  'tax.receipt.list.searchBar.filter.type': 'Tipo de nota',
  'tax.receipt.list.searchBar.filter.situation': 'Situação',
  'tax.receipt.list.searchBar.filter.issueDate': 'Data de emissão',
  'tax.receipt.general.form.company': 'Empresa',
  'tax.receipt.general.form.model': 'Modelo',
  'tax.receipt.general.form.serie': 'Série',
  'tax.receipt.general.form.number': 'Número',
  'tax.receipt.general.form.taxKey': 'Chave fiscal',
  'tax.receipt.general.form.natureOfOperation': 'Natureza da operação',
  'tax.receipt.general.form.issuePurpose': 'Finalidade de emissão',
  'tax.receipt.general.form.situation': 'Situação',
  'tax.receipt.general.form.issueDate': 'Data de emissão',
  'tax.receipt.general.form.docType': 'Tipo de documento',
  'tax.receipt.general.form.finalCustomer': 'Consumidor Final',
  'tax.receipt.general.form.operationDestination': 'Destino operação',
  'tax.receipt.general.form.date': 'Data entrada/saída',
  'tax.receipt.general.form.issueType': 'Tipo de emissão',
  'tax.receipt.general.form.presenceIndicator': 'Indicador presença',
  'tax.receipt.general.form.uf': 'UF',
  'tax.receipt.general.form.city': 'Município',
  'tax.receipt.general.form.shippingICMS':
    'Frete, desepesas entram na base de cálculo ICMS ST',
  'tax.receipt.general.form.shippingIPI':
    'Frete, desepesas entram na base de cálculo IPI',
  'tax.receipt.receiver.form.receiverType': 'Tipo destinatário',
  'tax.receipt.receiver.form.registration': 'CPF/CNPJ',
  'tax.receipt.receiver.form.taxpayer': 'Tipo de contribuinte',
  'tax.receipt.receiver.form.customer': 'Cliente',
  'tax.receipt.items.list.header.manufacturer': 'Cód. Fabricante',
  'tax.receipt.items.list.header.description': 'Descrição',
  'tax.receipt.items.list.header.cfop': 'CFOP',
  'tax.receipt.items.list.header.ncm': 'NCM',
  'tax.receipt.items.list.header.quantity': 'Qtd',
  'tax.receipt.items.list.header.price': 'Valor Unit.',
  'tax.receipt.items.list.header.discount': 'Descontos',
  'tax.receipt.items.list.header.total': 'Valor Total',
  'tax.receipt.items.list.totals.items': 'Total Items',
  'tax.receipt.items.list.totals.insurance': 'Total seguro',
  'tax.receipt.items.list.totals.shipping': 'Total frete',
  'tax.receipt.items.list.totals.expenses': 'Total despesas',
  'tax.receipt.items.list.totals.discounts': 'Total despesas',
  'tax.receipt.items.list.totals.total': 'Total nota',
  'tax.receipt.items.button': 'Adicionar Item',
  'tax.receipt.items.modal.title.part': 'Selecione uma peça',
  'tax.receipt.items.modal.title.service': 'Selecione um serviço',
  'tax.receipt.items.modal.list.header.sku': 'Cod.',
  'tax.receipt.items.modal.list.header.description': 'Descrição',
  'tax.receipt.items.modal.list.action.button': 'Selecionar',
  'tax.receipt.delivery.form.name': 'Nome completo',
  'tax.receipt.delivery.form.type': 'Tipo',
  'tax.receipt.delivery.form.type.pf': 'Pessoa física',
  'tax.receipt.delivery.form.type.pj': 'Pessoa jurídica',
  'tax.receipt.delivery.form.cpf': 'CPF',
  'tax.receipt.delivery.form.cnpj': 'CNPJ',
  'tax.receipt.delivery.form.registration': 'Inscrição Estadual',
  'tax.receipt.delivery.form.phone': 'Telefone',
  'tax.receipt.delivery.form.zipcode': 'CEP',
  'tax.receipt.delivery.form.street': 'Logradouro',
  'tax.receipt.delivery.form.number': 'Número',
  'tax.receipt.delivery.form.complement': 'Complemento',
  'tax.receipt.delivery.form.district': 'Bairro',
  'tax.receipt.delivery.form.city': 'Cidade',
  'tax.receipt.delivery.form.uf': 'UF',
  'tax.receipt.taxes.form.icms': 'ICMS',
  'tax.receipt.taxes.form.icmsSt': 'ICMS ST',
  'tax.receipt.taxes.form.ipi': 'IPI',
  'tax.receipt.taxes.form.issqn': 'ISSQN',
  'tax.receipt.taxes.form.fcp': 'FCP',
  'tax.receipt.taxes.form.fcpSt': 'FCP ST',
  'tax.receipt.taxes.form.fcpStHold': 'FCP ST Retido',
  'tax.receipt.taxes.form.pis': 'PIS',
  'tax.receipt.taxes.form.pisSt': 'PIS ST',
  'tax.receipt.taxes.form.pisStHold': 'PIS ST Retido',
  'tax.receipt.taxes.form.cofins': 'COFINS',
  'tax.receipt.taxes.form.cofinsSt': 'COFINS ST',
  'tax.receipt.taxes.form.cofinsHold': 'COFINS Retido',
  'tax.receipt.transport.form.label.transport': 'Transporte',
  'tax.receipt.transport.form.shippingCompany': 'Transportadora',
  'tax.receipt.transport.form.shippingType': 'Tipo de frete',
  'tax.receipt.transport.form.label.transportVehicle': 'Veículo de transporte',
  'tax.receipt.transport.form.plate': 'Placa',
  'tax.receipt.transport.form.uf': 'UF',
  'tax.receipt.transport.form.rntc': 'RNTC',
  'tax.receipt.transport.form.label.volumes': 'Volumes',
  'tax.receipt.transport.form.quantity': 'Quantidade',
  'tax.receipt.transport.form.kind': 'Espécie',
  'tax.receipt.transport.form.brand': 'Marca',
  'tax.receipt.transport.form.numbering': 'Numeração',
  'tax.receipt.transport.form.grossWeight': 'Peso Bruto (Kg)',
  'tax.receipt.transport.form.netWeight': 'Peso Liq.(Kg)',
  'tax.receipt.payments.title.payments': 'Pagamentos',
  'tax.receipt.payments.title.billingData': 'Dados para cobrança',
  'tax.receipt.payments.button.new': 'Novo Pagamento',
  'tax.receipt.payments.button.newInstallment': 'Nova Parcela',
  'tax.receipt.payments.button.multiInstallments': 'Múltiplas parcelas',
  'tax.receipt.payments.list.header.paymentType': 'Tipo pagamento',
  'tax.receipt.payments.list.header.total': 'Valor',
  'tax.receipt.payments.list.header.flagCard': 'Bandeira cartão',
  'tax.receipt.payments.list.header.authorization': 'Número Autorização',
  'tax.receipt.payments.list.header.number': 'Número Parcela',
  'tax.receipt.payments.list.header.dueDate': 'Data de vencimento',
  'tax.receipt.payments.list.header.value': 'Valor da parcela',
  'tax.receipt.payments.form.changeValue': 'Valor do troco',
  'tax.receipt.payments.form.installmentNumber': 'Número da Parcela',
  'tax.receipt.payments.form.originalValue': 'Valor Original',
  'tax.receipt.payments.form.discountValue': 'Valor desconto',
  'tax.receipt.payments.form.netValue': 'Valor líquido',
  'tax.receipt.payments.modal.title': 'Pagamentos',
  'tax.receipt.payments.modal.form.paymentType': 'Tipo pagamento',
  'tax.receipt.payments.modal.form.value': 'Valor',
  'tax.receipt.payments.modal.form.integrationType': 'Tipo de integração',
  'tax.receipt.payments.modal.form.cnpj': 'CNPJ credenciadora',
  'tax.receipt.payments.modal.form.flagCard': 'Bandeira cartão',
  'tax.receipt.payments.modal.form.authorization': 'Número autorização',
  'tax.receipt.payments.modal.form.cardAcquirer':
    'Credenciadora de cartão - SAT',
  'tax.receipt.payments.installments.modal.title': 'Dados para cobrança',
  'tax.receipt.payments.installments.modal.form.installmentNumber':
    'Número da parcela',
  'tax.receipt.payments.installments.modal.form.installmentQuantity':
    'Quant. de parcelas',
  'tax.receipt.payments.installments.modal.form.value': 'Valor da parcela',
  'tax.receipt.payments.installments.modal.form.dueDate': 'Data de vencimento',
  'tax.receipt.additional.form.taxAdditionalData':
    'Informações adicionais de interesse do fisco',
  'tax.receipt.additional.form.taxpayerAdditionalData':
    'Informações adicionais de interesse do contribuinte',
};
